<div class="container">
    <div class="close" (click)="this.dialogRef.close(false)">
        <img src="assets/icons/news/close.svg" alt="close modal" />
    </div>
    <h1 class="title"> Confirmá tus datos personales </h1>
    <form>
        <div class="row" *ngIf="askForAddress()">
            <mat-form-field appearance="outline">
                <mat-label>Provincia</mat-label>
                <mat-select [formControl]="provinceControl" (selectionChange)="citySelector()">
                    <mat-option *ngFor="let province of provinces" [value]="province">
                        {{ province }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Localidad</mat-label>
                <mat-select [formControl]="cityControl">
                    <mat-option *ngFor="let option of options" [value]="option">
                        {{ option }}
                    </mat-option>
                </mat-select>
                <mat-error for="register-name" class="form-error"
                    *ngIf="(!cityControl.pristine || cityControl.touched) && cityControl.invalid">
                    {{ getErrorMessage('locality') }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="row" *ngIf="askForAddress()">
            <mat-form-field appearance="outline">
                <mat-label>Calle</mat-label>
                <input matInput type="text" [formControl]="addressStreetControl" (keyup.enter)="addInformation()" />
                <mat-error for="register-name" class="form-error" *ngIf="
                    (!addressStreetControl.pristine || addressStreetControl.touched) &&
                    addressStreetControl.invalid
                  ">
                    {{ getErrorMessage('addressStreet') }}
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Altura</mat-label>
                <input matInput type="text" mask="99999" [formControl]="addressNumberControl"
                    (keyup.enter)="addInformation()" />
                <mat-error for="register-name" class="form-error" *ngIf="
                    (!addressNumberControl.pristine || addressNumberControl.touched) &&
                    addressNumberControl.invalid
                  ">
                    {{ getErrorMessage('addressNumber') }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="row" *ngIf="askForAddress()">
            <mat-form-field appearance="outline">
                <mat-label>Piso / Apt. (Opcional)</mat-label>
                <input matInput type="text" [formControl]="addressFloorControl" (keyup.enter)="addInformation()" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Código Postal</mat-label>
                <input matInput type="text" mask="9999" [formControl]="postalControl"
                    (keyup.enter)="addInformation()" />
                <mat-error for="register-name" class="form-error"
                    *ngIf="(!postalControl.pristine || postalControl.touched) && postalControl.invalid">
                    {{ getErrorMessage('postalCode') }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="row" *ngIf="askForPhone()">
            <mat-form-field class="big" appearance="outline">
                <mat-label>Número de teléfono</mat-label>
                <input matInput mask="0000000000" type="text" [formControl]="phoneControl" placeholder="Teléfono" />
                <mat-error *ngIf="(!phoneControl.pristine || phoneControl.touched) && phoneControl.invalid">
                    {{ getErrorMessage('phone') }}
                </mat-error>
            </mat-form-field>
        </div>
        <button class="td-btn primary" (click)="addInformation()">Confirmar datos</button>
    </form>
</div>